import { environment } from "@enviroments/environment";
import { AuthUtil } from "./auth.util";
import { ValidationUtil } from "./validation.util";
import { ConvertUtil } from "./convert.util";

export class CartUtil {
  static getParamsAddToCart(pdtCd: string, qty: number, ordNoTmp: string): any {
    let member = AuthUtil.getLoginedInfo();
    if (member) {
      let params = {
        comId: environment.comId,
        userid: member.userid,
        userKindCd: member.userKindCd,
        cntCd: member.cntCd,
        pathCD: environment.comCd + "T30",
        pdtCd: pdtCd,
        qty: qty,
        workUser: member.userid,
        workKind: "M",
        directYN: "Y", 
        ordNoTmp: ordNoTmp
      };
      return params;
    }
    return null;
  }

  static getParamsAddToLinkCart(item: any, pdtCd: string, qty: number): any {
    if (ValidationUtil.isNotNullAndNotEmpty(item)) {
      let params = {
        comId: environment.comId,
        userid: item.userid,
        userKindCd: environment.comCd + "U10",
        cntCd: item.cntCd,
        pathCD: environment.comCd + "T30",
        pdtCd: pdtCd,
        qty: qty,
        workUser: item.userid,
        workKind: "M",
        directYN: "Y", 
        ordNoTmp: item.ordNoTmp
      };
      return params;
    }
    return null;
  }

  static getParamsAddToCartNotLogin(item: any, qty: number): any {
    if (ValidationUtil.isNotNullAndNotEmpty(item)) {
      let params = {
        pdtCd: ConvertUtil.convertToSring(item.pdtCd),
        qty: qty,
        pdtName: ConvertUtil.convertToSring(item.pdtName),
        amt: item.amt,
        cateNameOrg: item.cateNameOrg,
        ordYN: 'Y',
        filePath: item.filePath,
        fileName: item.fileName,
        retailAmt: item.retailAmt
      };
      return params;
    }
    return null;
  }

  static getParamSaveOrdYn(item: any, ordYN: string, userkindCd: any): any {
    let params = {
      comId: environment.comId,
      userid: item.userid,
      userKindCd: userkindCd,
      cntCd: item.cntCd,
      pathCD: environment.comCd + "T30",
      pdtCd: item.pdtCd,
      qty: 0,
      workUser: item.userid,
      workKind: 'M',
      directYN: 'Y', 
      ordNoTmp: item.ordNoTmp,
      ordYN: ordYN
    };
    return params;
  }
}